export const permissions = {
  view: 'supplier.view_provideragreement',
  add: 'supplier.add_provideragreement',
  change: 'supplier.change_provideragreement',
  delete: 'supplier.delete_provideragreement',
};
